<template>
    <div class="part2 part">
        <p class="title">
          <el-row>
            <el-col :span="6">
              <el-row class="box">
                <el-col :span="10" class="pic">
                  <img src="../../static/images/part2_1.png" alt="">
                </el-col>
                <el-col :span="14" class="info">
                  <p>深度定制的</p>
                  <p>平台化产品</p>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row class="box">
                <el-col :span="10" class="pic">
                  <img src="../../static/images/part2_2.png" alt="">
                </el-col>
                <el-col :span="14" class="info">
                  <p>层级分明的</p>
                  <p>人员管理体系</p>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row class="box">
                <el-col :span="10" class="pic">
                  <img src="../../static/images/part2_3.png" alt="">
                </el-col>
                <el-col :span="14" class="info">
                  <p>高效便捷的</p>
                  <p>工作协同机制</p>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row class="box">
                <el-col :span="10" class="pic">
                  <img src="../../static/images/part2_4.png" alt="">
                </el-col>
                <el-col :span="14" class="info">
                  <p>专业多远的</p>
                  <p>延伸服务</p>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </p>
    </div>
</template>
<script>
export default {
    name :"Parttwo",
    data(){
        return{
            
        }
    }
}
</script>
<style scoped>
  .part2{
    background: #f4faf8;
  }
  .part2 p.title{
    height: 100px;
    width: 1200px;
		margin: 0 auto;
  }
  .part2 .box{
    width:170px;
    height: 100px;
    margin: 0 auto;
    text-align: center;
  }
  .part2 .box .pic{
    width:60px;
    margin-top: 20%;
  }
  .part2 .box .info{
    color: #666;
    line-height: 26px;
    margin-top:20px;
    text-align: left;
  }
  .part2 .box .info p{
    margin: 0;
  }
	@media (max-width: 1439px){
    .part2 p.title{
      width: 1000px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Parttwo.vue